import { Product, Customer, Address, VoucherOrNone } from "@raskrask-dk/raskrask-utils";
import {Next, ChoosePaymentMethod, SetPrice} from "./actions";

export type CheckoutActions = Next | ChoosePaymentMethod | SetPrice;
export const checkoutActions = [Next, ChoosePaymentMethod, SetPrice] as const;
export type checkActions = typeof checkoutActions[number];

export type ProductCheckout = {
  product: Product;
  customer: Customer;
  address: Address;
  promoCode?: string;
  voucher?: VoucherOrNone;
};

export type CheckoutStateDependencies = ProductCheckout;
